module.exports = __webpack_public_path__ + "img/smD2.4d817dad.png";